import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAccessFeedback } from './utils/accessFeedback';
import { installSessionExpiry } from './utils/sessionExpiry';

// API URL interceptor - replaces localhost with production URL
const _originalFetch = window.fetch;
window.fetch = function(url, options) {
  if (typeof url === 'string' && url.includes('localhost:5000')) {
    url = url.replace(
      'http://localhost:5000',
      process.env.REACT_APP_API_URL || 'http://localhost:5000'
    );
  }
  return _originalFetch(url, options);
};
// Role-based refusals get one clear message instead of a silent failure (utils/accessFeedback.js)
window.fetch = installAccessFeedback(window.fetch);
// An expired/invalid login token signs the user out and returns to the sign-in screen (utils/sessionExpiry.js)
window.fetch = installSessionExpiry(window.fetch);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();